import React, { useEffect } from 'react'
import Navbar from '../../components/Navbar/Navbar'
import MyContactInfo from '../../components/MyContactInfo/MyContactInfo'
import { connect } from 'react-redux'
import { getUserDetails } from '../../redux/slices/userSlice'

const MyContactInfoPage = ({getUser}) => {

  useEffect(() => {
    getUser()
  }, [])
  
  return (
    <main>
      <Navbar showSeasonDropdown={false} />
      <MyContactInfo />
    </main>
  )
}

const mapDispatchToProps = (dispatch) => ({
  getUser: () => dispatch(getUserDetails()),
});

export default connect(null, mapDispatchToProps)(MyContactInfoPage);